<template>
  <div>
    <div class="query-select">
      <el-form :inline="true" :model="queryForm">
        <el-form-item label="标题">
          <el-input
            style="width: 220px"
            v-model.trim="queryForm.newsTitle"
            clearable
            placeholder="请输入标题"
            @keyup.enter.native="search"
          ></el-input>
        </el-form-item>
        <el-form-item label="来源">
          <el-input
            style="width: 180px"
            v-model.trim="queryForm.source"
            clearable
            placeholder="请输入来源"
            @keyup.enter.native="search"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          plain
          round
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >查询</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="warning"
          icon="el-icon-refresh-left"
          @click="resetSelect"
          >重置</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="success"
          icon="el-icon-plus"
          @click="openForm('add')"
          >新增</el-button
        >
      </div>
    </div>

    <div class="main-table">
      <el-table
        header-cell-class-name="table-header"
        stripe
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="拼命加载中"
        style="width: 85vw"
      >
        <el-table-column
          align="center"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="newsTitle"
          label="标题"
          min-width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column align="center" label="封面" width="100">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.coverImage"
              :src="scope.row.coverImage"
              :preview-src-list="[scope.row.coverImage]"
              fit="contain"
              style="height:100px"
            ></el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="source"
          label="来源"
          min-width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="newsSummary"
          label="摘要"
          min-width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="link"
          label="链接"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="publishTime"
          label="发布时间"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ formatDateOnly(scope.row.publishTime) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="创建时间"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ formatDateOnly(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button
              plain
              round
              size="small"
              type="primary"
              @click="openForm('edit', scope.row)"
              >编辑</el-button
            >
            <el-button
              plain
              round
              size="small"
              type="danger"
              @click="deleteInfo(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="totals"
      >
      </el-pagination>
    </div>

    <NewsForm ref="newsFormRef" @success="search" />
  </div>
</template>

<script>
import { getNewsList, deleteNews } from "@/api/content/news";
import NewsForm from "./NewsForm.vue";

export default {
  name: "News",
  components: { NewsForm },
  data() {
    return {
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        newsTitle: "",
        source: ""
      },
      listData: [],
      totals: 0,
      loading: false
    };
  },
  created() {
    this.search();
  },
  methods: {
    formatDateOnly(value) {
      if (!value) return "-";
      return String(value).slice(0, 10);
    },
    handleCurrentChange(val) {
      this.queryForm.pageNum = val;
      this.search();
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNum = 1;
      this.search();
    },
    resetSelect() {
      this.queryForm = {
        pageNum: 1,
        pageSize: 10,
        newsTitle: "",
        source: ""
      };
      this.search();
    },
    async search() {
      this.loading = true;
      try {
        const params = { ...this.queryForm };
        Object.keys(params).forEach(key => {
          if (
            params[key] === "" ||
            params[key] === undefined ||
            params[key] === null
          ) {
            delete params[key];
          }
        });
        const result = await getNewsList(params);
        const data = (result && result.data) || {};
        this.listData = data.rows || [];
        this.totals = Number(data.total) || 0;
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    openForm(type, row) {
      this.$refs.newsFormRef.open(type, row);
    },
    deleteInfo(row) {
      this.$confirm("确定要删除该新闻吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            await deleteNews(row.newsId);
            this.$message.success("删除成功");
            this.search();
          } catch (e) {}
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/views/News/index.vue